import React from 'react'
// import backgroudImg from '../../public/img/*'
import { Link } from 'react-router-dom';

const AbroadMERBLI = () => {
  return (
    <>
    <div className='container abroad-merbli-img' >
<Link to={"mailto:info@phgfoundationafrica.org?subject=Applying for Abroad Project Monitoring & Evaluation"}>
    <button className='btn btn-primary'>Reach Us</button>
</Link>
    </div>
    </>
  )
}

export default AbroadMERBLI